import { useCallback, useState } from 'react';
import { readQuickStartDismissed, shouldShowQuickStart, writeQuickStartDismissed } from './quickStartGuide';

/**
 * Wires quickStartGuide.ts's pure dismiss/re-enable logic to React state +
 * localStorage — mirrors useOnboardingGate.ts's own thin-hook shape (a pure
 * module underneath, this file only holds the useState/useCallback plumbing).
 *
 * Shared by Home.tsx (renders the guide + owns the dismiss X) and
 * Settings.tsx (the "Show the quick start again" re-entry — nothing
 * unrecoverable, per the no-deletion spirit applied to UI) so both surfaces
 * read/write the exact same localStorage key through one source of truth,
 * never two independent copies that could drift.
 */
export function useQuickStartGuide() {
  const [dismissed, setDismissed] = useState<boolean>(() => readQuickStartDismissed());

  const dismiss = useCallback(() => {
    writeQuickStartDismissed(true);
    setDismissed(true);
  }, []);

  const reEnable = useCallback(() => {
    writeQuickStartDismissed(false);
    setDismissed(false);
  }, []);

  return { dismissed, visible: shouldShowQuickStart(dismissed), dismiss, reEnable };
}
